import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'bh-button',
    templateUrl: './button.component.html',
})
export class ButtonComponent {
    @Input() theme: 'light' | 'dark' = 'light';
    @Input() isDisable: boolean = false;
}
